// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"232":"f1e97a5e","484":"e5c5c935"}[chunkId] + ".chunk.css";
};